// metaDataMap.js
const innerAppMetaDataMap = {
  "royal-star": {
    title:
      "Royal Star Vinyl Flooring India | Premium Commercial & Residential Flooring",
    description:
      "Discover Royal Star vinyl flooring in India — premium quality, durable, stylish floors ideal for commercial & residential spaces. Water-resistant, easy‑to‑maintain, with a luxurious finish.",
    keywords:
      "Royal Star vinyl flooring, vinyl flooring India, premium vinyl floors India, luxury vinyl flooring, waterproof vinyl flooring, easy maintenance flooring, commercial residential vinyl India",
  },
  tiger: {
    title:
      "Tiger Vinyl Flooring India | Rugged & Stylish PVC Flooring for hospitals & More",
    description:
      "Tiger vinyl flooring in India – strong, stylish, slip‑resistant PVC floors ideal for educational, commercial & residential spaces. Easy to install & maintain.",
    keywords:
      "Tiger vinyl flooring, tiger PVC flooring India, education flooring, hospital vinyl flooring India, durable flooring solutions, slip resistant flooring, commercial vinyl flooring, residential vinyl India",
  },
  "royal-classic": {
    title:
      "Royal Classic Vinyl Flooring India | Timeless & Durable Hotels Flooring",
    description:
      "Royal Classic vinyl flooring in India – elegant, hard-wearing PVC floors perfect for residential, hotels & leisure environments. Slip-resistant, low-maintenance and stylish.",
    keywords:
      "Royal Classic vinyl flooring, residential vinyl flooring India, durable flooring India, classic PVC floors, hotels flooring solutions, slip resistant vinyl, Leisure & Hospitality Vinyl Flooring",
  },
  majesty: {
    title: "Majesty Vinyl Flooring India | Elegant & Hard‑Wearing PVC Flooring",
    description:
      "Majesty vinyl flooring in India – premium PVC floors with realistic wood look, slip‑resistant PU coating and high scratch & stain resistance for showroom, hotels and Leisure & Hospitality.",
    keywords:
      "Majesty vinyl flooring, vinyl flooring India, wood look vinyl India, PU coated vinyl flooring, durable PVC flooring India, showroom vinyl flooring, hotels vinyl India",
  },
  tuff: {
    title:
      "Tuff Vinyl Flooring India | Ultra‑Tough PVC Flooring for Education & Heavy‑Use Spaces",
    description:
      "Tuff vinyl flooring in India – ultra‑durable, slip‑resistant PVC floors designed for educational institutions, gyms, commercial & industrial spaces. Easy to install and maintain.",
    keywords:
      "Tuff vinyl flooring, heavy duty vinyl flooring India, education vinyl flooring, school PVC flooring India, commercial vinyl floors, slip resistant vinyl India, durable flooring solutions",
  },
  orbit: {
    title:
      "Orbit Healthcare Vinyl Flooring India | Hygienic & Impact‑Resistant PVC Flooring",
    description:
      "Orbit healthcare vinyl flooring in India – durable, hygienic, impact-resistant PVC flooring ideal for hospitals, clinics & labs. Easy to sanitize, slip-resistant, and cost-efficient.",
    keywords:
      "Orbit vinyl flooring, healthcare vinyl flooring India, hospital PVC flooring, clinic vinyl flooring India, hygienic flooring India, impact-resistant healthcare flooring, easy-clean vinyl flooring",
  },

  "majesty-pro": {
    title:
      "Majesty Pro Residential Vinyl Flooring India | Elegant Wood‑Look PVC Flooring",
    description:
      "Natroyal is a leading Indian manufacturer of automotive coated fabrics, exporting premium quality faux leatheMajesty Pro residential vinyl flooring in India – premium wood‑look PVC flooring with PU wear‑layer, slip‑resistant, scratch‑defend and water‑resistant—perfect for living rooms, bedrooms & more.",
    keywords:
      "Majesty Pro vinyl flooring, residential vinyl flooring India, wood-look PVC flooring, PU coated vinyl flooring, scratch-resistant vinyl India, waterproof home flooring, elegant vinyl flooring",
  },
  opera: {
    title:
      "Opera Residential Vinyl Flooring India | Elegant & Easy‑Care PVC Flooring",
    description:
      "Opera residential vinyl flooring in India – stylish, easy-maintenance PVC floors with wood, geometric & printed designs. Water-resistant, scratch-resistant and perfect for  residential and small shops.",
    keywords:
      "Opera vinyl flooring, residential vinyl flooring India, printed vinyl flooring, wood-look vinyl India, easy-care PVC flooring, waterproof vinyl flooring India, elegant home flooring",
  },
  "printed-flooring": {
    title:
      "Printed Vinyl Flooring India | Stylish, Waterproof & Affordable Home Flooring",
    description:
      "Explore printed vinyl flooring in India—vibrant designs, water-resistant & easy to maintain. Perfect for living rooms, kitchens, bathrooms! Affordable and durable vinyl solutions.",
    keywords:
      "printed vinyl flooring India, residential printed vinyl flooring, decorative vinyl flooring, waterproof vinyl flooring India, affordable home vinyl flooring, patterned PVC flooring India",
  },
  "suprema-rs": {
    title:
      "Suprema RS Vinyl Flooring | Commercial Office & Retail Flooring India - Natroyal",
    description:
      "Upgrade your workspace with Suprema RS – high-performance vinyl flooring ideal for offices, showrooms, and retail spaces in India. Durable, stylish, and easy to maintain by Natroyal.",
    keywords:
      "Suprema RS vinyl flooring, office vinyl flooring India, retail vinyl flooring India, commercial vinyl tiles, premium vinyl flooring, durable flooring for showrooms, shop flooring solutions, heavy duty vinyl flooring India, Natroyal Suprema RS, vinyl flooring for malls",
  },
  "standard-rs": {
    title:
      "Standard RS Vinyl Flooring | Commercial Office & Retail Flooring in India - Natroyal",
    description:
      "Explore Standard RS – affordable and durable vinyl flooring ideal for offices, showrooms, and retail spaces in India. Perfect for high-traffic commercial areas. From Natroyal.",
    keywords:
      "Standard RS vinyl flooring, commercial vinyl flooring India, office flooring solutions, retail shop vinyl tiles, affordable vinyl flooring India, durable vinyl tiles for offices, vinyl flooring for showrooms, PVC flooring for commercial use, Natroyal vinyl flooring",
  },
  sonata: {
    title:
      "Sonata Vinyl Flooring for transport owners | Transport Flooring India - Natroyal",
    description:
      "Discover Sonata – premium vinyl flooring designed for transport in India. Ideal for discerning bus, coach builders, fleet owners, and transport. Durable, elegant & easy to maintain – by Natroyal.",
    keywords:
      "Sonata vinyl flooring, hospitality vinyl flooring India, transport flooring solutions, transport vinyl flooring, vinyl flooring for fleet owners, transport flooring India, Natroyal Sonata, transport flooring manufacturer, luxury vinyl flooring India, durable vinyl for hospitality",
  },
  "eco-plus-v": {
    title: "Eco Plus V Vinyl Flooring | Transport Flooring India - Natroyal",
    description:
      "Eco Plus V by Natroyal offers elegant, cost-effective vinyl flooring for transport spaces across India. Ideal for transport, hotels, restaurants, and banquet halls with high foot traffic..",
    keywords:
      "Eco Plus V vinyl flooring, transport flooring India, transport vinyl flooring, transport flooring solutions, transport vinyl flooring India, commercial vinyl flooring India, Natroyal Eco Plus V, durable vinyl flooring India, eco-friendly vinyl flooring",
  },
  gripper: {
    title:
      "Gripper Vinyl Flooring for Transport | Bus Flooring, Airports & Automotive Mats - Natroyal",
    description:
      "Gripper vinyl flooring by Natroyal is designed for Indian transport – offering superior grip, slip resistance, and durability. Ideal for bus application, airports, and automobile floor mats.",
    keywords:
      "Gripper vinyl flooring, transport vinyl flooring India, bus vinyl flooring, airport flooring India, floor mats for automobiles, anti-slip vinyl flooring, commercial vehicle flooring, metro coach flooring, PVC transport flooring, Natroyal Gripper flooring",
  },
};

export default innerAppMetaDataMap;
